import { render, staticRenderFns } from "./CompetitionTermsAndConditions.vue?vue&type=template&id=845c9eba"
import script from "./CompetitionTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./CompetitionTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./CompetitionTermsAndConditions.vue?vue&type=style&index=0&id=845c9eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports